module.exports = __webpack_public_path__ + "static/img/fushineiyi.9d8d8f0.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/fushineiyi.png
// module id = OVjH
// module chunks = 0